


























import {
  Component,
  Vue,
  Prop
} from "@/shared/vuepack";
import { HsabExpenseEvidenceResponse, WexUploadStatusMap } from "@/shared/types";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";
import { useHsabExpenseEvidenceStore } from "@/employee/store/hsabExpenseEvidence";
import moment from "moment-timezone";

@Component({})
export default class AccountHolderExpenseEvidence extends Vue {
  expenseEvidenceStore = useHsabExpenseEvidenceStore();
  WexUploadStatusMap = WexUploadStatusMap;

  @Prop()
  expenseEvidence: HsabExpenseEvidenceResponse[];

  @Prop()
  hsabExpenseId: number;

  @Prop({ required: true })
  username: string;

  @Prop({ required: true })
  partnerId: number;

  truncateFileName (filename) {
    const maxLength = 20;
    const postfixCharacterCount = 7;
    if (filename.length > maxLength) {
      return filename.slice(0, maxLength - (postfixCharacterCount + 3)) + "..." +
          filename.slice(filename.length - postfixCharacterCount, filename.length);
    }
    return filename;
  }
  getFormattedDate (date?: string): string {
    if (isNullEmptyOrUndefined(date)) {
      return "N/A";
    }
    const local = moment.utc(date).local();
    if (isNullEmptyOrUndefined(local.zoneAbbr())) {
      return `${local.format("MM/D/YYYY hh:mma")} ${local.tz(moment.tz.guess()).zoneAbbr()}`;
    }
    return local.format("MM/D/YYYY hh:mma z");
  }
  openAttachment (evidence) {
    const args = { username: this.username, partnerId: this.partnerId };
    this.expenseEvidenceStore.OpenAttachment(this.hsabExpenseId, evidence.hsabExpenseEvidenceId, args);
  }

  listFields = [{
    key: "fileName",
    label: "File Name",
    thClass: "text-left small",
    tdClass: "small"
    },
    {
      key: "dateCreated",
      label: "Created",
      thClass: "small",
      tdClass: "small"
    },
    {
      key: "dateUploaded",
      label: "Uploaded",
      thClass: "small",
      tdClass: "small"
    },
    {
      key: "wexUploadStatus",
      label: "Status",
      thClass: "text-left small",
      tdClass: "text-left small"
    }];
}
